import React, { PureComponent, Fragment } from 'react';

import { navigateToMainPage } from '../../../components/nav/IndexLink';

import {
  SettingsChangeListener,
  SettingsEventListener,
} from '../../../components/context/settings';

import getFeedUrl from '../../../lib/settings/getFeedUrl';

import { SettingsPubSubEvent } from '@wix/podcasts-common/dist/settings';
import { WidgetPage } from '@wix/podcasts-common/dist/widget';

import { ISettings } from '../../../lib/settings/types';

function isCriticalSettingsChanged(
  settings: ISettings,
  prevSettings: ISettings,
) {
  return getFeedUrl(settings) !== getFeedUrl(prevSettings);
}

class EpisodePageSettingsListener extends PureComponent {
  onSettingsChanged = (settings: ISettings, prevSettings: ISettings) => {
    if (isCriticalSettingsChanged(settings, prevSettings)) {
      // @ts-expect-error
      window.location.reload(true);
    }
  };

  onSettingsPageChanged = (data: { page: WidgetPage }) => {
    if (data.page === WidgetPage.MAIN) {
      navigateToMainPage();
    }
  };

  render() {
    return (
      <Fragment>
        <SettingsChangeListener onChanged={this.onSettingsChanged} />
        <SettingsEventListener
          event={SettingsPubSubEvent.WIDGET_PAGE_CHANGE}
          onEvent={this.onSettingsPageChanged}
        />
      </Fragment>
    );
  }
}

export default EpisodePageSettingsListener;
